import { Component } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
  selector: "app-footer",
  standalone: true,
  imports: [
    TranslatePipe
],
  templateUrl: "./footer.component.html",
  styleUrls: ["./footer.component.css"]
})
export class FooterComponent {

  getCurrentYear(): number {
    return new Date().getFullYear();
  }
}


